import { LetterList } from '@/components/letters/letter-list';
import { type Letter, letters as lettersApi } from '@/lib/api';
import { Loader2, Send } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function SentPage() {
  const { t } = useTranslation();
  const [letters, setLetters] = useState<Letter[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLetters = async () => {
      try {
        const data = await lettersApi.getSent();
        setLetters(data ?? []);
      } catch (error) {
        console.error('Failed to fetch sent letters:', error);
        setLetters([]);
      } finally {
        setLoading(false);
      }
    };

    fetchLetters();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-16">
        <Loader2 className="w-8 h-8 text-sepia animate-spin" />
      </div>
    );
  }

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-serif text-ink">{t('sent.title')}</h1>
        <p className="text-sepia/70">{t('sent.subtitle')}</p>
      </div>

      <LetterList
        letters={letters}
        emptyIcon={<Send className="w-8 h-8 text-sepia/50" />}
        emptyTitle={t('sent.empty')}
        emptyDescription={t('sent.emptyDesc')}
        showRecipient
      />
    </div>
  );
}
